export class AccountPlan {
    name: string;
    id: number;
    code: string;
    alias: string;
    type: string;
    fixed: boolean;
    operational: boolean;
    financial: boolean;
    parent: AccountPlan;
    companyList : any[]; // Assuming companyList is an array of objects or IDs
}